import { NgModule, ErrorHandler } from '@angular/core';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { ElectronicFilingModule } from './Electronic-Filing/electronicFiling.module';
import { EntityImportModule } from './Entity-Import/entityImport.module';
import { AssetModule } from './Asset/asset.module';
import { FormModule } from './Form/form.module';
import { AgGridModule } from 'ag-grid-angular';
import { BusyIndicatorModule } from '../Busy-Indicator';
import { FactorTableModule } from './Factor-Table/factorTable.module';
import { GLAccountModule } from './GL-Account/glAccount.module';
import { FilingBatchModule } from './Filing-Batch/filingBatch.module';
import { ReturnModule } from './Return/return.module';
import { SupplementalInformationModule } from './Supplemental-Information/supplementalInformation.module';
import { LongRunningProcessModule } from './Long-Running-Process/longRunningProcess.module';
import {
    EntityImportRepository,
    AssetRepository,
    CostAdjustmentRepository,
    AssetClassificationRepository,
    FactorTableRepository,
    FormRepository,
    GLAccountRepository,
    FilingBatchRepository,
    ReturnRepository,
    ReturnAssetRepository,
    ReturnFormRepository,
    ReturnFormRevisionRepository,
    SupplementalInformationRepository,
    ReturnFormRevisionReportRepository,
    ReturnReportRepository,
    ReturnSettingsRepository,
    GridLayoutSpecificationRepository,
    CompanyAssetDescriptorRepository,
    LongRunningProcessRepository,
    ReportingParcelRepository,
    ErrorLogRepository,
    QueryInfoRepository,
    DataHubLogRepository,
    TaxFeedLogRepository,
    TaxDotComDocsSvcLogRepository,
    ImportSpecificationRepository,
    CompanyRepository,
    IncomeStatementCategoryRepository,
    AssessorCommandCenterRepository
} from './Repositories';
import { httpInterceptorProviders } from '../Common/Data/HttpInterceptors';
import { GlobalErrorHandler } from '../Common/ErrorHandler/globalErrorHandler';
import { LoggingService } from '../Common/Logging/logging.service';
import { AgGridMultiSelectedHeaderRenderer, AgGridMultiSelectedCellRenderer } from './AgGrid/MultiSelectTracker';
import { WeissmanModalService } from './WeissmanModalService';
import { EntityPickerService } from './Entity-Picker/entityPicker.service';
import { EntityPickerComponent } from './Entity-Picker/entityPicker.component';
import { WeissmanMutexService } from './WeissmanMutexService';
import { ComplianceParcelModule } from './Parcel/parcel.module';
import { AgGridDateFilterComponent } from './AgGrid';
import { ComplianceCompanyModule } from './Company/company.module';
import { ComplianceInfoRepository } from './Repositories/complianceInfo.repository';
import { ComplianceSiteModule } from './Site/site.module';
import { ErrorLogModule } from '../Diagnostics/Error-Log/errorLog.module';
import { QueryInfoModule } from '../Diagnostics/Query-Info/queryInfo.module';
import { DataHubLogModule } from '../Diagnostics/Data-Hub-Log/dataHubLog.module';
import { TaxAccessSyncLogModule } from '../Diagnostics/Tax-Access-Sync-Log/taxAccessSyncLog.module';
import { LeadDocketLogModule } from '../Diagnostics/Lead-Docket-Log/leadDocketLog.module';
import { TaxFeedLogModule } from '../Diagnostics/Tax-Feed-Log/taxFeedLog.module';
import { TaxDotComDocsSvcLogModule } from '../Diagnostics/TaxDotCom-DocsSvc-Log/taxDotComDocsSvcLog.module';
import { ImportRecalculationErrorsModule } from '../Diagnostics/Import-Recalculation-Errors/importRecalculationErrors.module';
import { FormSetupRepository } from './Repositories';
import { StateJurisdictionModule } from './State-And-Jurisdiction/stateJurisdiction.module';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { AllocationModule } from './Allocation/allocation.module';
import { FormLibraryRepository } from './Repositories/formLibraryRepository';
import { DataHubLogService } from '../Diagnostics/Data-Hub-Log/dataHubLog.service';
import { LeadDocketLogService } from '../Diagnostics/Lead-Docket-Log/leadDocketLog.service';
import { TaxFeedLogService } from '../Diagnostics/Tax-Feed-Log/taxFeedLog.service';
import { TaxDotComDocsSvcLogService } from '../Diagnostics/TaxDotCom-DocsSvc-Log/taxDotComDocsSvcLog.service';

import { GetLogFilesModule } from '../Diagnostics/Get-Log-Files/getLogFiles.module';
import { HistoryLookupRepository } from '../Diagnostics/History-Lookup/historyLookup.repository';
import { HistoryLookupService } from '../Diagnostics/History-Lookup/historyLookup.service';
import { HistoryLookupModule } from '../Diagnostics/History-Lookup/historyLookup.module';

@NgModule({
    imports: [
        WeissmanSharedModule,
        EntityImportModule,
        AssetModule,
        FactorTableModule,
        FormModule,
        GLAccountModule,
        FilingBatchModule,
        ReturnModule,
        ComplianceCompanyModule,
        ComplianceSiteModule,
        ComplianceParcelModule,
        StateJurisdictionModule,
        SupplementalInformationModule,
        LongRunningProcessModule,
        ErrorLogModule,
        QueryInfoModule,
        DataHubLogModule,
        TaxAccessSyncLogModule,
        LeadDocketLogModule,
        TaxFeedLogModule,
        TaxDotComDocsSvcLogModule,
        ImportRecalculationErrorsModule,
        BusyIndicatorModule.forRoot(),
        AgGridModule,
        AllocationModule,
        ElectronicFilingModule,
        GetLogFilesModule,
        HistoryLookupModule,
    ],
    declarations: [EntityPickerComponent],
    providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        httpInterceptorProviders,
        LoggingService,
        EntityImportRepository,
        ImportSpecificationRepository,
        AssetRepository,
        AssetClassificationRepository,
        CostAdjustmentRepository,
        FactorTableRepository,
        FormRepository,
        GLAccountRepository,
        FilingBatchRepository,
        ReturnRepository,
        ReturnAssetRepository,
        ReturnFormRepository,
        ReturnFormRevisionRepository,
        ReturnFormRevisionReportRepository,
        ReturnReportRepository,
        SupplementalInformationRepository,
        ReturnSettingsRepository,
        GridLayoutSpecificationRepository,
        WeissmanModalService,
        WeissmanMutexService,
        EntityPickerService,
        CompanyAssetDescriptorRepository,
        LongRunningProcessRepository,
        ErrorLogRepository,
        QueryInfoRepository,
        DataHubLogRepository,
        DataHubLogService,
        TaxFeedLogRepository,
        TaxFeedLogService,
        TaxDotComDocsSvcLogRepository,
        TaxDotComDocsSvcLogService,
        ReportingParcelRepository,
        ComplianceInfoRepository,
        FormSetupRepository,
        CompanyRepository,
        AssessorCommandCenterRepository,
        IncomeStatementCategoryRepository,
        FormLibraryRepository,
        HistoryLookupRepository,
        HistoryLookupService,
    ],
    exports: [],
})
export class ComplianceModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        EntityImportModule.setupModule();
        AssetModule.setupModule();
        FactorTableModule.setupModule();
        FormModule.setupModule();
        GLAccountModule.setupModule();
        FilingBatchModule.setupModule();
        ReturnModule.setupModule();
        SupplementalInformationModule.setupModule();
        LongRunningProcessModule.setupModule();
        ErrorLogModule.setupModule();
        QueryInfoModule.setupModule();
        DataHubLogModule.setupModule();
        TaxAccessSyncLogModule.setupModule();
        LeadDocketLogModule.setupModule();
        TaxFeedLogModule.setupModule();
        TaxDotComDocsSvcLogModule.setupModule();
        ImportRecalculationErrorsModule.setupModule();
        ComplianceParcelModule.setupModule();
        ComplianceCompanyModule.setupModule();
        ComplianceSiteModule.setupModule();
        StateJurisdictionModule.setupModule();
        hybridAdapterUtility.downgradeNg2Provider('longRunningProcessRepository', LongRunningProcessRepository);
        AllocationModule.setupModule();
        ElectronicFilingModule.setupModule();
        GetLogFilesModule.setupModule();
        HistoryLookupModule.setupModule();
    }
}
